var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _circle, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _circle2, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 865.6 658.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M308 153.2a1.4 1.4 0 0 1-1.5-1.3 50.2 50.2 0 0 0-50-46.5 51 51 0 0 0-4.7.2 1.4 1.4 0 0 1-1.3-.7 59.7 59.7 0 0 0-109.1 13 1.4 1.4 0 0 1-1.4 1h-1A42 42 0 0 0 98 152a1.4 1.4 0 0 1-1.4 1.1H1.4a1.4 1.4 0 0 1 0-2.8h94A45 45 0 0 1 139 116a62.5 62.5 0 0 1 113.6-13.3l4-.2a53 53 0 0 1 52.8 49.2 1.4 1.4 0 0 1-1.3 1.5ZM291 171.5H58a1.4 1.4 0 1 1 0-2.9h233a1.4 1.4 0 1 1 0 2.9ZM114.8 192H36.7a1.4 1.4 0 1 1 0-2.8h78.1a1.4 1.4 0 0 1 0 2.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M187.9 468.5c0 57.7-60.6 85.4-60.6 85.4S66.2 526.2 65 468.5a61 61 0 0 1 61.5-61.5 61.5 61.5 0 0 1 61.5 61.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M147.8 557.3h-40.9l-5-19.9h50.9l-5 19.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M108.2 591.3h38.2v19.9h-38.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M146.8 611.5h-38.9V591h38.9Zm-38.2-.6H146v-19.3h-37.5ZM135.2 559.6h-15.7l-1.8-2.8H137l-1.8 2.8zM107.2 557.3h.6v30.4h-.6zM146.9 557.3h.6v30.4h-.6zM133.6 537l-.4-.4c18-13.8 39.3-37.5 39.3-71.9a61 61 0 0 0-37.3-56.4l.2-.5a61.7 61.7 0 0 1 37.7 57c0 34.5-21.5 58.4-39.5 72.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "m113.7 537-.4-.4c18-13.8 39.3-37.5 39.3-71.9a61.2 61.2 0 0 0-36.9-56.2l.3-.6a61.8 61.8 0 0 1 37.3 56.8c0 34.6-21.6 58.5-39.6 72.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M139.1 537c-18-13.8-39.5-37.7-39.5-72.3a61.8 61.8 0 0 1 37.3-56.8l.2.6a61.2 61.2 0 0 0-37 56.2c0 34.4 21.5 58 39.4 71.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M119.3 537c-18-13.8-39.6-37.7-39.6-72.3a61.7 61.7 0 0 1 38-57l.2.5a61 61 0 0 0-37.6 56.5c0 34.4 21.4 58 39.3 71.9ZM126.1 407h.6v130.4h-.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m108.2 598.4 11.4-11.4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "m108 598.2 11.4-11.4.4.4-11.4 11.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m108.2 604.6 17-17.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "m108 604.4 17-17.8.4.4-17 17.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103.4 586.8H150v5.6h-46.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M150.3 592.7h-47.2v-6.2h47.2Zm-46.6-.6h46v-5h-46Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M305 322.1c0 38.1-39.9 56.4-39.9 56.4S224.7 360.2 224 322a40.3 40.3 0 0 1 40.6-40.6 40.6 40.6 0 0 1 40.6 40.6Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M278.7 380.7h-27.1l-3.3-13.1h33.6l-3.2 13.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M252.5 403.2h25.2v13.1h-25.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M278 416.5h-25.7V403H278Zm-25.3-.4h24.8v-12.7h-24.8ZM270.3 382.3H260l-1.2-1.9h12.7l-1.2 1.9zM251.8 380.7h.4v20.1h-.4zM278 380.7h.4v20.1h-.4zM269.2 367.4l-.2-.3c11.8-9.2 26-24.8 26-47.5a40.3 40.3 0 0 0-24.7-37.2l.1-.4a40.7 40.7 0 0 1 25 37.6c0 22.8-14.3 38.6-26.2 47.8Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "m256.1 367.4-.2-.3c11.8-9.2 26-24.8 26-47.5a40.4 40.4 0 0 0-24.5-37l.2-.5a40.8 40.8 0 0 1 24.6 37.5c0 22.8-14.2 38.6-26 47.8Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M272.9 367.4c-12-9.2-26.1-25-26.1-47.8a40.8 40.8 0 0 1 24.6-37.5l.2.4a40.4 40.4 0 0 0-24.4 37.1c0 22.7 14.1 38.3 26 47.5Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M259.8 367.4c-12-9.2-26.1-25-26.1-47.8a40.7 40.7 0 0 1 25-37.6l.2.3a40.3 40.3 0 0 0-24.8 37.3c0 22.7 14 38.3 26 47.5ZM264.3 281.5h.4v86.1h-.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m252.5 407.8 7.5-7.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "m252.4 407.7 7.5-7.5.3.3-7.5 7.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m252.5 411.9 11.2-11.7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "m252.4 411.8 11.1-11.7.3.3-11.1 11.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M249.3 400.2H280v3.7h-30.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M280.3 404H249v-4h31.2Zm-30.8-.3H280v-3.3h-30.4ZM644.9 374.2a1 1 0 0 0 1-1 36 36 0 0 1 35.8-33.3c1 0 2.2 0 3.4.2a1 1 0 0 0 1-.5 42.8 42.8 0 0 1 78.1 9.3 1 1 0 0 0 1 .7h.7a30.2 30.2 0 0 1 29.4 23.8 1 1 0 0 0 1 .8h68.3a1 1 0 1 0 0-2H797a32.2 32.2 0 0 0-31.1-24.6 44.8 44.8 0 0 0-81.4-9.6l-3-.1a38 38 0 0 0-37.8 35.2 1 1 0 0 0 1 1.1ZM657 387.3h167a1 1 0 1 0 0-2H657a1 1 0 0 0 0 2ZM783.3 402h56a1 1 0 0 0 0-2h-56a1 1 0 1 0 0 2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f616a",
    d: "M523 647.8h-3.4l-1.6-13h5v13z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M523.8 651H513v-.1a4.2 4.2 0 0 1 4.2-4.2h6.6Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f616a",
    d: "m566.2 641.4-2.9 1.7-8-10.2 4.3-2.6 6.6 11.1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M559.4 649.3h-.1a4.2 4.2 0 0 1 1.4-5.9l5.7-3.4 2.2 3.8ZM523.9 645.1a45 45 0 0 1-5-.3l-2-.2h-.1c-.5-.1-.6-5.3-.3-23 0-9 .2-19.3 0-25.8v-.1h.1a24.6 24.6 0 0 1 21.6-5.5h.1c3.3 5.6 8.3 13.6 13.1 21.4 11 17.8 14.2 23 13.9 23.5l-1.9.9a59.4 59.4 0 0 1-5.8 2.6h-.2a155 155 0 0 1-26.3-38.7l-2.4 16A262.8 262.8 0 0 1 524 645Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M526.9 597a58.7 58.7 0 0 1 19.6 3.4 44.7 44.7 0 0 0-10-29.2v-.1a518 518 0 0 0 5.2-15.6c-1.2-4.1-3.6-8.2-7.5-12.6a2.4 2.4 0 0 0-3.3-.1 30.5 30.5 0 0 0-9.8 24.8c-3 10.3-4.2 15.6-5.2 20.3-.7 3.4-1.3 6.4-2.5 10.6a63.6 63.6 0 0 1 13.5-1.4Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m536.7 564.4-9.9 21.6-5.7-5.7 15.6-15.9z",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 532.5,
    cy: 533.8,
    r: 7.1,
    fill: "#9f616a"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M524 529.8H535v-5c-2.4-.9-4.8-1.7-6.3 0a4.9 4.9 0 0 0-4.9 5Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M535.7 524c6.7 0 8.6 8.4 8.6 13.2 0 2.6-1.2 3.5-3 3.9l-.7-3.6-1.6 3.7h-1.6l-.5-1-1.2 1c-4.7 0-8.5.7-8.5-4 0-4.8 1.6-13.2 8.5-13.2Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M738 198c0 186-195 275-195 275s-197-89-201-275C339.8 88.7 430.8 0 540 0s198 88.6 198 198Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb7b7",
    d: "M547.3 646.3h-4.1l-2-15.8h6.1v15.8z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M540.2 645.1h8v5h-13a5 5 0 0 1 5-5Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb7b7",
    d: "M562.7 646.3h-4.1l-2-15.8h6.1v15.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M555.6 645.1h8v5h-13a5 5 0 0 1 5-5Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb7b7",
    d: "M562.2 599a3.6 3.6 0 0 1-.7-5.4l-2.7-38.4 7.8.8.2 37.6a3.6 3.6 0 0 1-4.6 5.5Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m547 638.3-4.4-.2a1.5 1.5 0 0 1-1.5-1.5l-.3-45.8a1.5 1.5 0 0 1 1.7-1.5l18.1 2.6a1.5 1.5 0 0 1 1.3 1.5l2.3 42.5a1.5 1.5 0 0 1-1.5 1.5H558a1.5 1.5 0 0 1-1.5-1.3s-3.7-31.8-4.2-31.8-3.6 32.7-3.6 32.7a1.5 1.5 0 0 1-1.4 1.3h-.1Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M560.6 568.1a1.5 1.5 0 0 1-.7-1.1l-.5-10.4a4.2 4.2 0 0 1 8.1-1.3l2.5 9.3a1.5 1.5 0 0 1-1 1.8l-7.2 2a1.5 1.5 0 0 1-1.2-.3Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 553.9,
    cy: 535.3,
    r: 8.2,
    fill: "#ffb7b7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M559.7 541.8a2.7 2.7 0 0 1-4.6-1.5 2.7 2.7 0 0 1 0-.5c.1-1 .7-1.9.6-3a1.5 1.5 0 0 0-.3-.7c-1.2-1.6-4.1.8-5.3-.7-.7-1 .2-2.4-.4-3.4-.7-1.3-2.8-.7-4.2-1.4-1.4-.8-1.4-3-.4-4.5a7 7 0 0 1 5.4-2.7 14.3 14.3 0 0 1 6 1.2 12 12 0 0 1 5.7 4 9.6 9.6 0 0 1 1 8.2c-.5 1.6-2.2 3.6-3.5 5Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m562.1 549-.4-.3a10.8 10.8 0 0 0-2.6-1.2v-2.2h-6.3v2a11.2 11.2 0 0 0-8.1 9.3l-4.4 32.2a1.5 1.5 0 0 0 .3 1.1 1.5 1.5 0 0 0 1 .6 22.8 22.8 0 0 1 8.7 3 12.8 12.8 0 0 0 6.2 1.5 15.1 15.1 0 0 0 5.1-.9 1.5 1.5 0 0 0 1-1.3c.2-3.5 1-21.3 3.7-32.2a11.1 11.1 0 0 0-4.2-11.6ZM609.1 484h-132l-16-64h164l-16 64z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M481.6 593.5h123v64.1h-123z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M605.6 658.5h-125v-66h125Zm-123-2h121v-62h-121ZM568.3 491.5h-50.4l-5.8-9h62l-5.8 9zM478.1 484h2v98h-2zM606.1 484h2v98h-2zM563.1 419l-1.2-1.7c57.8-44.5 126.7-120.9 126.7-231.5A196.7 196.7 0 0 0 568.3 4.3l.7-1.8a198.7 198.7 0 0 1 121.6 183.3c0 111.5-69.3 188.3-127.5 233.1Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m499.1 419-1.2-1.7c57.8-44.5 126.7-120.9 126.7-231.5A197 197 0 0 0 505.6 5l.8-1.8a199 199 0 0 1 120.2 182.7c0 111.5-69.3 188.3-127.5 233.1Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M581 419c-58-45-127.4-121.7-127.4-233.2A199 199 0 0 1 573.8 3.1l.8 1.8a197 197 0 0 0-119 181c0 110.5 68.9 186.9 126.7 231.4Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M517 419c-58-45-127.4-121.7-127.4-233.2A198.6 198.6 0 0 1 512 2.1l.7 1.9a196.6 196.6 0 0 0-121 181.8c0 110.6 68.8 187 126.6 231.5ZM539.1 0h2v420h-2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m481.6 616.3 36.7-36.7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m480.9 615.6 36.7-36.7 1.4 1.4-36.7 36.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m481.6 636.3 54.5-57.3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m480.9 635.7 54.5-57.4 1.4 1.4-54.5 57.3z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M466.1 579h150v18h-150z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M617 598H465v-20h152Zm-150-2h148v-16H467Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f616a",
    d: "M514.6 587.4a2.7 2.7 0 0 0 2.5-3.4l8.2-5.4-4.7-2-7 5.4a2.8 2.8 0 0 0 1 5.4Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M522.5 583.5h-.1l-6.2-4.4h-.2l.1-.2c4.5-5.2 9-10.7 13.3-16l-1.4-10.4a6.7 6.7 0 0 1 .2-7.2 5.7 5.7 0 0 1 7.3-1.7 4.8 4.8 0 0 1 2.2 3.6 4.4 4.4 0 0 1-1.2 3.6 150.5 150.5 0 0 1 .6 15.3c-4.6 5.9-9.7 11.7-14.5 17.3Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb7b7",
    d: "M524 551.4a3.5 3.5 0 0 1 .1.6l14.4 8.3 3.5-2 3.8 4.9-7.5 5.3-16.5-13a3.5 3.5 0 1 1 2.3-4Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M539 559.6a1.5 1.5 0 0 1 .5-1.2l7.3-7.4a4.2 4.2 0 0 1 6.4 5.2l-5.2 8a1.5 1.5 0 0 1-2 .5l-6.3-4a1.5 1.5 0 0 1-.7-1.1Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbcbcb",
    d: "M439.3 488.2a1 1 0 0 1-1-1 36 36 0 0 0-35.8-33.3c-1 0-2.2 0-3.4.2a1 1 0 0 1-1-.5 42.8 42.8 0 0 0-78.2 9.3 1 1 0 0 1-1 .7h-.7a30.2 30.2 0 0 0-29.4 23.8 1 1 0 0 1-1 .8h-68.2a1 1 0 1 1 0-2H287a32.2 32.2 0 0 1 31.2-24.6 44.8 44.8 0 0 1 81.4-9.6l3-.1a38 38 0 0 1 37.7 35.2 1 1 0 0 1-1 1.1ZM427.2 501.3h-167a1 1 0 1 1 0-2h167a1 1 0 1 1 0 2ZM301 516h-56a1 1 0 1 1 0-2h56a1 1 0 1 1 0 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.84c341215ceee7411adcab8074c4b3b0.svg";
export { ForwardRef as ReactComponent };